import React from "react";

const SmsSection2 = () => {
  return (
    <div>
      <div className="bg-[#F0FDFF] py-12 sm:py-16 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <h1
            className="
          text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 
             tracking-tight !leading-[120%]
            font-semibold text-[#3E4247]
          "
          >
            From Admission to Graduation — Manage It All Effortlessly
          </h1>

          <p
            className="
           mt-3 sm:mt-4 md:mt-6 lg:mt-8
            text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 
            leading-relaxed
            font-normal text-[#3E4247]
          "
          >
            MUN-C’s all-in-one School ERP System helps educational institutions
            automate daily tasks, save time, and improve efficiency.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SmsSection2;
